module.exports = __webpack_public_path__ + "img/csm_wadin_7d39e20e46.cb61dced.jpg";